<template>
  <section
    id="offer"
    class="pt-[135px] pb-5 max-[1199px]:pt-[63px] md:pb-14 min-[1200px]:pb-[104px]"
  >
    <div class="mx-auto w-full max-w-container">
      <h2 class="m-0 pl-8 md:px-4 font-extrabold text-[#333] text-center max-[767px]:pl-0 md:text-left">
        <Translate translate-key="landing_offer.title" />
      </h2>
      <ul class="m-0 grid list-none grid-cols-1 gap-6 p-0 md:grid-cols-2">
        <li
          v-for="item in items"
          :key="item.id"
          class="flex relative flex-col rounded-xl bg-white p-6 pt-[50px] pb-5 shadow-xl mx-9 max-[1199px]:pt-[65px] md:mx-0 md:pb-10"
        >
          <div class="flex flex-col items-center gap-4">
            <NuxtImg
              :src="item.imageSrc"
              :width="item.imageWidth"
              :height="item.imageHeight"
              format="webp"
              :alt="t(item.imageAltKey)"
              loading="lazy"
              class="mb-5 object-contain"
            />
            <h3 class="m-0 mb-2 font-semibold text-[#333]">
              <Translate :translate-key="item.subtitleKey" />
            </h3>
          </div>
          <div сlass="flex flex-col items-center justify-center ">
            <p class="m-0 mb-20 md:mb-14 flex-grow text-[#666]">
              <Translate :translate-key="item.textKey" />
            </p>
          </div>
          <div class="flex absolute bottom-10 -mx-6 w-full justify-center">
            <Button
              :id="item.buttonId"
              :as="NuxtLink"
              variant="landingOutline"
              class="self-center"
              :to="item.to"
            >
              <Translate :translate-key="item.buttonKey" />
            </Button>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import { NuxtLink } from "#components";
import { useI18n } from "vue-i18n";
import { Button } from "~/shared/components/ui/button";
import Translate from "~/shared/components/i18n/Translate/Translate.vue";

const { t } = useI18n();

const items = [
  {
    id: "tradeline-brokers",
    imageSrc: "/offer/tradeline-brokers.png",
    imageWidth: 112,
    imageHeight: 93,
    imageAltKey: "landing_offer.image_1_alt",
    subtitleKey: "landing_offer.subtitle",
    textKey: "landing_offer.text",
    buttonId: "learnMoreAffiliateProgram",
    buttonKey: "landing_offer.become_a_broker",
    to: "/tradeline-brokerage",
  },
  {
    id: "sell-your-tradelines",
    imageSrc: "/offer/sell-your-tradelines.png",
    imageWidth: 93,
    imageHeight: 93,
    imageAltKey: "landing_offer.image_2_alt",
    subtitleKey: "landing_offer.subtitle_2",
    textKey: "landing_offer.text_2",
    buttonId: "learnMoreSellingTradelines",
    buttonKey: "landing_offer.start_selling",
    to: "/selling-tradelines",
  },
] as const;
</script>
